<form [formGroup]="stepForm" *ngIf="stepForm">
  <h5 class="nmbcol">{{ "Sellers.Products.BasicInfo" | translate }}</h5>
  <div class="cardbg-white">
  <div class="row justify-content-end">
    <div class="col-md-6 mb-4">
      <app-number [fieldObject]="controllers['Amount']"
                  [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertControls(controllers['Amount'].fieldName)"
                  [productType]="productTypeId"
                  [isUpdate]="isUpdate"></app-number>
    </div>
    <div class="col-md-6 mb-4">
      <app-select-list [fieldObject]="controllers['Viewing Currency']"
                        [fieldErrors]="formValidator.formErrors"
                        [formControlRef]="convertControls('Viewing Currency')"
                        [productType]="productTypeId"
                        [isUpdate]="isUpdate"></app-select-list>
    </div>
    <div class="col-md-12">
      <app-text-area [fieldObject]="controllers['Description']"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls(controllers['Description'].fieldName)"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-text-area>
    </div>
    <div class="col-12 mb-4 d-flex ">
      <app-toggle [fieldObject]="controllers['is_buyer_info']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertControls(controllers['is_buyer_info'].fieldName)"
                  [productType]="productTypeId" [isUpdate]="isUpdate"></app-toggle>
    </div>
  </div>
  </div>
</form>
